import SyncIcon from "@mui/icons-material/Sync";
import React, { useState, useEffect } from "react";
import {
  AlertState,
  SiteSchedule,
  SiteInfo,
  SiteCameras,
} from "./SiteAboutPageUtils/siteAboutInterfaces";
import { NavigateFunction } from "react-router-dom";
import { handleSyncSite } from "./SiteAboutPageUtils/handleSyncSite";
import {
  Dialog,
  Tooltip,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@mui/material";
import { timeSinceLastSync } from "./SiteAboutPageUtils/timeSinceLastSync";
import { useSiteAboutStore } from "./siteAboutStore/siteAboutStore";
import { OrangeTextButton } from "../../../common/OrangeTextButton";

type Dispatcher<S> = React.Dispatch<React.SetStateAction<S>>;

export const SyncSiteButton = ({
  syncNeeded,
  setBackdropLoadingScreenOn,
  setSyncNeeded,
  setAlertState,
  siteInfo,
  setSiteInfo,
  setAllSiteSchedules,
  setActiveTab,
  vmsVariables,
  setSiteDeployed,
  setDeativateInquiryDialogOpen,
  setSiteCameras,
  camerasNotDeployed,
  setCamerasNotDeployed,
  navigate,
  setVmsVariables,
  setClickedTab,
  setArmButtonDisabled,
  setArmedStatus,
  setRebootDialogOpen,
}: {
  syncNeeded: boolean;
  setBackdropLoadingScreenOn: Dispatcher<boolean>;
  setSyncNeeded: Dispatcher<boolean>;
  setAlertState: Dispatcher<AlertState>;
  siteInfo: SiteInfo;
  setSiteInfo: Dispatcher<SiteInfo>;
  setAllSiteSchedules: Dispatcher<SiteSchedule[]>;
  setActiveTab: Dispatcher<JSX.Element>;
  vmsVariables: (string | string[] | undefined)[][];
  setSiteDeployed: Dispatcher<boolean>;
  setDeativateInquiryDialogOpen: Dispatcher<boolean>;
  setSiteCameras: Dispatcher<SiteCameras>;
  camerasNotDeployed: boolean;
  setCamerasNotDeployed: Dispatcher<boolean>;
  navigate: NavigateFunction;
  setVmsVariables: Dispatcher<(string | string[] | undefined)[][]>;
  setClickedTab: Dispatcher<string>;
  setArmButtonDisabled: any;
  setArmedStatus: any;
  setRebootDialogOpen: Dispatcher<boolean>;
}) => {
  // State to hold the formatted time string
  const [timeString, setTimeString] = useState<string>(
    timeSinceLastSync(siteInfo.deployed_date)
  );

  const [syncSiteButtonDialogOpen, setSyncSiteButtonDialogOpen] =
    useState(false);

  const {
    syncSiteNeeded,
    syncPending,
    setSyncSiteNeededAlertOpen,
  } = useSiteAboutStore();

  // Effect to update the time string every minute
  useEffect(() => {
    // Update immediately when deployed_date changes
    setTimeString(timeSinceLastSync(siteInfo.deployed_date));

    // Set up interval to update every minute
    const intervalId = setInterval(() => {
      setTimeString(timeSinceLastSync(siteInfo.deployed_date));
    }, 60000); // 60000 ms = 1 minute

    // Clean up interval on component unmount
    return () => clearInterval(intervalId);
  }, [siteInfo.deployed_date]); // Re-run effect when deployed_date changes

  return (
    <div>
      <Dialog
        open={syncSiteButtonDialogOpen}
        onClose={() => setSyncSiteButtonDialogOpen(false)}
      >
        <DialogContent>
          <DialogContentText>
            All site settings have been synced. Syncing not needed.
          </DialogContentText>
          <br></br>
          <DialogContentText>Would you like to sync anyways?</DialogContentText>
          <DialogActions>
            <OrangeTextButton
              onClick={() => setSyncSiteButtonDialogOpen(false)}
              text="Cancel"
              disabled={false}
            />
            <OrangeTextButton
              onClick={() => {
                setSyncSiteButtonDialogOpen(false);
                setSiteDeployed(true);
                setBackdropLoadingScreenOn(true);
                setSyncSiteNeededAlertOpen(false);
                handleSyncSite(
                  setBackdropLoadingScreenOn,
                  setAlertState,
                  siteInfo,
                  setSiteInfo,
                  setSyncNeeded,
                  setAllSiteSchedules,
                  setActiveTab,
                  vmsVariables,
                  setSiteDeployed,
                  setDeativateInquiryDialogOpen,
                  setSiteCameras,
                  camerasNotDeployed,
                  setCamerasNotDeployed,
                  navigate,
                  setVmsVariables,
                  setClickedTab,
                  setArmButtonDisabled,
                  setArmedStatus,
                  setRebootDialogOpen
                );
              }}
              text="Sync"
              disabled={false}
            />
          </DialogActions>
        </DialogContent>
      </Dialog>
      <Tooltip
        title={
          syncPending
            ? "Sync requested — waiting for the site to confirm the deploy."
            : syncNeeded
            ? ""
            : `All site settings have been synced. Syncing not needed.  Last synced ${timeString}.`
        }
        placement="top"
        sx={{ fontSize: "15px", fontFamily: "mulish" }}
      >
        {syncPending ? (
          <button
            className="shadow-button bg-[#ed6c02] rounded font-mulish text-white text-base	p-1.5 cursor-wait"
            disabled={true}
          >
            <SyncIcon fontSize="small" className="animate-spin" />
            &nbsp; Syncing... &nbsp;
          </button>
        ) : !syncNeeded && !syncSiteNeeded ? (
          // <span>
          //   <button
          //     className="shadow-button bg-actuate-grey rounded font-mulish text-white text-base	p-1.5"
          //     disabled={true}
          //   >
          //     <SyncIcon fontSize="small" />
          //     &nbsp; Sync Site &nbsp;
          //   </button>
          // </span>
          <button
            className="shadow-button bg-[#2e7d32] rounded font-mulish text-white text-base	p-1.5 hover:bg-[#1b5e20]"
            onClick={() => {
              setSyncSiteButtonDialogOpen(true);
              // setBackdropLoadingScreenOn(true);
              // setSyncNeeded(false);
              // setSyncSiteNeeded(false);
              // setSyncSiteNeededAlertOpen(false);
              // handleSyncSite(
              //   setBackdropLoadingScreenOn,
              //   setAlertState,
              //   siteInfo,
              //   setSiteInfo,
              //   setSyncNeeded,
              //   setAllSiteSchedules,
              //   setActiveTab,
              //   vmsVariables,
              //   setSiteDeployed,
              //   setDeativateInquiryDialogOpen,
              //   setSiteCameras,
              //   camerasNotDeployed,
              //   setCamerasNotDeployed,
              //   navigate,
              //   setVmsVariables,
              //   setClickedTab,
              //   setArmButtonDisabled,
              //   setArmedStatus
              // );
            }}
            disabled={false}
          >
            <SyncIcon fontSize="small" />
            &nbsp; Sync Site &nbsp;
          </button>
        ) : (
          <button
            className="shadow-button bg-[#d32f2f] rounded font-mulish text-white text-base	p-1.5 hover:bg-[#c62828]"
            onClick={() => {
              setSiteDeployed(true);
              setBackdropLoadingScreenOn(true);
              setSyncSiteNeededAlertOpen(false);
              handleSyncSite(
                setBackdropLoadingScreenOn,
                setAlertState,
                siteInfo,
                setSiteInfo,
                setSyncNeeded,
                setAllSiteSchedules,
                setActiveTab,
                vmsVariables,
                setSiteDeployed,
                setDeativateInquiryDialogOpen,
                setSiteCameras,
                camerasNotDeployed,
                setCamerasNotDeployed,
                navigate,
                setVmsVariables,
                setClickedTab,
                setArmButtonDisabled,
                setArmedStatus,
                setRebootDialogOpen
              );
            }}
            disabled={false}
          >
            <SyncIcon fontSize="small" />
            &nbsp; Sync Site &nbsp;
          </button>
        )}
      </Tooltip>
    </div>
  );
};
